<template>
  <b-overlay :show="loading" opacity="0.99">
    <form v-on:submit="update" method="post">
      <WarningMessage
        v-if="!permission('edit', 'user_group')"
        message="Você não tem permissão para modificar grupos de usuários"
      />
      <div class="row">
        <div class="col-md-12 pt-0">
          <LabelRequiredField label="Nome" />
          <input
            :disabled="!permission('edit', 'user_group')"
            type="text"
            ref="autofocus"
            v-model="name"
            class="form-control"
          />
        </div>
        <div class="col-md-12">
          <label>Descrição</label>
          <input
            :disabled="!permission('edit', 'user_group')"
            type="text"
            v-model="description"
            class="form-control"
          />
        </div>
        <div class="col-md-12 pt-0">
          <WarningRequiredFields v-if="permission('edit', 'user_group')" />
          <h6 class="mb-0 worksansr">
            Criação:
            {{ formatDate(item.created_at) }}
          </h6>
          <h6 class="mb-0 worksansr">
            Última alteração:
            {{ formatDate(item.updated_at) }}
          </h6>
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="row pl-2 pr-2">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-left">
            <confirmation-dialog
              v-if="permission('remove', 'user_group')"
              :disabled="loading"
              message-title="Confirmar"
              message-body="DESEJA REAMENTE REMOVER O GRUPO DE USUÁRIOS"
              open-text="EXCLUIR"
              open-class="btn-delete mr-2"
              open-left-icon="fa-trash mr-2"
              @yes="handleDelete"
            />
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-right">
            <v-btn
              v-if="permission('edit', 'user_group')"
              :disabled="loading"
              type="submit"
              class="btn-save"
            >
              <i class="fas fa-save mr-2 text-twenty"></i>
              {{ loading ? "Carregando" : "SALVAR" }}
            </v-btn>
          </div>
        </div>
      </div>
    </form>
  </b-overlay>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import WarningMessage from "../Components/WarningMessage";
import LabelRequiredField from "../Components/LabelRequiredField";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import ConfirmationDialog from "../Components/ConfirmationDialog";

import permission from "../../lib/permission";

import { formatDate } from "../../lib/format";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "Edit",

  components: {
    ErrorsMessages,
    WarningMessage,
    WarningRequiredFields,
    LabelRequiredField,
    ConfirmationDialog,
  },

  props: {
    item: { type: Object },
  },

  data() {
    return {
      id: "",
      name: "",
      description: "",
      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    formatDate,

    async retrieve() {
      this.errors = [];
      this.id = this.item.id;
      this.name = this.item.name;
      this.description = this.item.description;
      setTimeout(() => this.$refs.autofocus.focus(), 10);
    },

    async update(event) {
      try {
        event.preventDefault();

        this.loading = true;

        const { id, name, description } = this;

        let params = { id, name, description };

        const response = await api.patch("/rest-home/group", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide(`edit_${String(id)}`);
          this.$emit("success");
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleDelete() {
      try {
        const { id } = this;

        let data = { id };

        const response = await api.delete("/rest-home/group", { data });

        const { error, errors, message } = response.data;
        if (!error) {
          this.errors = [];
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>